// extracted by mini-css-extract-plugin
module.exports = {"burgerBanner":"BurgerBanner_burgerBanner__n9gZ_","burgerBannerLink":"BurgerBanner_burgerBannerLink__7_BIG","burgerBannerImage":"BurgerBanner_burgerBannerImage__ySVLS"};